export default {
  PAPI: {
    GET_CLOUD_TIME: {
      method: 'GET',
      path: () => `${window.cloud.url}/papi/cloud/time`
    },
    PASSWORD_INIT: {
      method: 'POST',
      path: () => `${window.cloud.url}/papi/password/init`
    }
  },
  COMMON: {
    GET_OTP_FCW: {
      method: 'GET',
      path: () => `${window.cloud.url}/common/otp/fcw`
    }
  },
  SESSIONS: {
    FASOO_LOGIN: {
      method: 'POST',
      path: () => `${window.cloud.url}/sessions/fasoo/login`
    },
    FASOO_LOGIN_CHECK: {
      method: 'POST',
      path: () => `${window.cloud.url}/sessions/fasoo/login/check`
    },
    FASOO_LOGIN_OTP: {
      method: 'POST',
      path: () => `${window.cloud.url}/sessions/fasoo/login/otp`
    },
    LOGOUT: {
      method: 'POST',
      path: () => `${window.cloud.url}/sessions/logout`
    },
    JOIN: {
      method: 'POST',
      path: () => `${window.cloud.url}/sessions/join`
    },
    LOGIN: {
      method: 'POST',
      path: () => `${window.cloud.url}/sessions/login`
    },
    SEND_TOKEN: {
      method: 'POST',
      path: () => `${window.cloud.url}/sessions/join/token`
    },
    CHECK_USERID: {
      method: 'POST',
      path: () => `${window.cloud.url}/sessions/check/userid`
    },
    WITHDRAWAL: {
      method: 'POST',
      path: () => `${window.cloud.url}/sessions/withdrawal`
    }
  },
  CLOUD: {
    GET_SERVICE_LIST: {
      method: 'GET',
      path: (offset, limit, order) =>
        `${window.cloud.url}/console/cloud/service/list?offset=${offset}&limit=${limit}&order=${order}`
    },
    GET_SERVICE_OPTION_LIST: {
      method: 'POST',
      path: () => `${window.cloud.url}/console/cloud/service/list`
    },
    START_SERVICE: {
      method: 'POST',
      path: () => `${window.cloud.url}/console/cloud/service/start`
    },
    STOP_SERVICE: {
      method: 'POST',
      path: () => `${window.cloud.url}/console/cloud/service/stop`
    },
    TERMINATE_SERVICE: {
      method: 'POST',
      path: () => `${window.cloud.url}/console/cloud/service/delete`
    },
    GET_LICENSE_LIST: {
      method: 'GET',
      path: (offset, limit, order) =>
        `${window.cloud.url}/console/cloud/license/list?offset=${offset}&limit=${limit}&order=${order}`
    },
    CHECK_SERVICE_ID: {
      method: 'POST',
      path: () => `${window.cloud.url}/console/cloud/service/check/url`
    },
    DESCRIBE_SERVICE: {
      method: 'GET',
      path: serviceUid =>
        `${window.cloud.url}/wapi/cloud/service/status/${serviceUid}`
    },
    DELETE_SERVICE: {
      method: 'POST',
      path: () => `${window.cloud.url}/wapi/cloud/service/delete`
    },
    GET_SERVICE_BILL_HISTORY: {
      method: 'GET',
      path: serviceUid =>
        `${window.cloud.url}/console/cloud/service/bill/history/${serviceUid}`
    },
    GET_STATS: {
      method: 'GET',
      path: (startDate, endDate, product) =>
        `${window.cloud.url}/console/cloud/service/stats?startDate=${startDate}&endDate=${endDate}&product=${product}`
    },
    SET_TOTAL_PRICE: {
      method: 'POST',
      path: () => `${window.cloud.url}/console/cloud/service/bill/history/price`
    },
    GET_USER_NXAC: {
      method: 'GET',
      path: product =>
        `${window.cloud.url}/wapi/cloud/nxac/service/myList?product=${product}`
    }
  },
  CONSOLE: {
    GET_SERVICE_MY_LIST: {
      method: 'GET',
      path: product =>
        `${window.cloud.url}/wapi/cloud/service/list?product=${product}`
    }
  },

  PAY: {
    APPLYCHECK_PROMOTIONCODE: {
      method: 'GET',
      path: product =>
        `${window.cloud.url}/wapi/cloud/pay/promotion/applyCheck?product=${product}`
    },
    CHECK_PROMOTIONCODE: {
      method: 'GET',
      path: (promotionCode, product) =>
        `${window.cloud.url}/wapi/cloud/pay/promotion/${promotionCode}?product=${product}`
    },
    CHECK_PROMOTION_TRIAL: {
      method: 'GET',
      path: product =>
        `${window.cloud.url}/wapi/cloud/pay/promotion/check/trial?product=${product}`
    },
    // GET_SERVICE_MY_LIST: {
    //   method: 'GET',
    //   path: () => `${window.cloud.url}/wapi/cloud/service/list`
    // },
    GET_UNREGISTER_BILL: {
      method: 'GET',
      path: (billType, product) =>
        `${window.cloud.url}/wapi/cloud/pay/service/bill/unregister/${billType}?product=${product}`
    },
    GET_MY_SERVICE_BILL: {
      method: 'GET',
      path: product =>
        `${window.cloud.url}/wapi/cloud/pay/service/bill/myList?product=${product}`
    },
    // // 사용자 결제 이력 목록 (2023-08-09 추가 - dongdev)
    // GET_MY_SERVICE_BILL_HISTORY: {
    //   method: 'GET',
    //   path: serviceBillUid =>
    //     `${window.cloud.url}/wapi/cloud/pay/service/bill/history/${serviceBillUid}`
    // },
    CREATE_SERVICE_BILL: {
      method: 'POST',
      path: () => `${window.cloud.url}/wapi/cloud/pay/service/bill/new`
    },
    CREATE_SERVICE_SITE: {
      method: 'POST',
      path: () => `${window.cloud.url}/wapi/cloud/pay/service/site/new`
    },
    CREATE_SERVICE_TRIAL: {
      method: 'POST',
      path: () => `${window.cloud.url}/wapi/cloud/pay/promotion/new/trial`
    },
    CREATE_SERVICE_PROMOTION_ASK: {
      method: 'POST',
      path: () => `${window.cloud.url}/wapi/cloud/pay/promotion/new/promotion`
    },
    GET_PROMOTION_LIST: {
      method: 'POST',
      path: () => `${window.cloud.url}/wapi/cloud/pay/promotion/list`
    },
    CREATE_PROMOTION: {
      method: 'POST',
      path: () => `${window.cloud.url}/wapi/cloud/pay/promotion/new`
    },
    UPDATE_PROMOTION: {
      method: 'POST',
      path: () => `${window.cloud.url}/wapi/cloud/pay/promotion/update`
    },
    GET_PRICE_LIST: {
      method: 'POST',
      path: () => `${window.cloud.url}/wapi/cloud/pay/price/list`
    },
    GET_COUNTRYCODE: {
      method: 'POST',
      path: () => `${window.cloud.url}/wapi/cloud/pay/countryCode`
    },
    CREATE_PRICE: {
      method: 'POST',
      path: () => `${window.cloud.url}/wapi/cloud/pay/price/new`
    },
    CHECK_SERVICE_ID: {
      method: 'POST',
      path: () => `${window.cloud.url}/wapi/cloud/service/check/url`
    },
    GET_BILL_HISTORY: {
      method: 'GET',
      path: (offset, limit, order, product) =>
        `${window.cloud.url}/wapi/cloud/pay/bill/history?offset=${offset}&limit=${limit}&order=${order}&product=${product}`
    },
    GET_BILL_HISTORY_UID: {
      method: 'GET',
      path: serviceBillHisUid =>
        `${window.cloud.url}/wapi/cloud/pay/bill/history/${serviceBillHisUid}`
    },
    UPDATE_SERVICE_NAME: {
      method: 'POST',
      path: () => `${window.cloud.url}/wapi/cloud/service/name`
    },
    GET_INICIS_DATA: {
      method: 'POST',
      path: () => `${window.cloud.url}/wapi/cloud/pay/service/getInicisData`
    },
    GET_CASH: {
      method: 'POST',
      path: () => `${window.cloud.url}/wapi/cloud/pay/service/cash`
    },
    REQUEST_CASH: {
      method: 'POST',
      path: () => `${window.cloud.url}/wapi/cloud/pay/service/cash/new`
    },
    GET_CASH_USER: {
      method: 'POST',
      path: () => `${window.cloud.url}/wapi/cloud/pay/service/cash/user`
    },
    UPDATE_CASH: {
      method: 'POST',
      path: () => `${window.cloud.url}/wapi/cloud/pay/service/cash/update`
    },
    SUBSCRIPTION_SUSPEND: {
      method: 'POST',
      path: product =>
        `${window.cloud.url}/wapi/cloud/pay/service/subscriptions/suspend/${product}`
    },
    SUBSCRIPTION_ACTIVATE: {
      method: 'POST',
      path: product =>
        `${window.cloud.url}/wapi/cloud/pay/service/subscriptions/activate/${product}`
    },
    CONFIRM_USER: {
      method: 'POST',
      path: () => `${window.cloud.url}/wapi/cloud/pay/service/confirm`
    },
    GET_SERVICE_NXAC_LIST: {
      method: 'GET',
      path: serviceUid =>
        `${window.cloud.url}/wapi/cloud/nxac/service/${serviceUid}/list`
    },
    SET_SERVICE_NXAC_LIST: {
      method: 'POST',
      path: serviceUid =>
        `${window.cloud.url}/wapi/cloud/nxac/service/${serviceUid}/update`
    },
    GET_TOTAL_NXAC_LIST: {
      method: 'GET',
      path: () => `${window.cloud.url}/wapi/cloud/nxac/list`
    },
    GET_NXAC_INFO: {
      method: 'GET',
      path: nxacAppUid => `${window.cloud.url}/wapi/cloud/nxac/${nxacAppUid}`
    },
    CREATE_NXAC: {
      method: 'POST',
      path: () => `${window.cloud.url}/wapi/cloud/nxac/create`
    },
    DELETE_NXAC: {
      method: 'POST',
      path: () => `${window.cloud.url}/wapi/cloud/nxac/delete`
    },
    UPDATE_NXAC: {
      method: 'POST',
      path: () => `${window.cloud.url}/wapi/cloud/nxac/update`
    },
    CHANGE_MANAGER: {
      method: 'POST',
      path: () => `${window.cloud.url}/wapi/cloud/pay/service/changeManager`
    }
  },
  PAYPAL: {
    SUBSCRIPTIONS_REVISE: {
      method: 'POST',
      path: id =>
        `${window.cloud.url}/wapi/cloud/paypal/v1/billing/subscriptions/${id}/revise`
    },
    GET_SUBSCRIPTION: {
      method: 'GET',
      path: id => `${window.cloud.url}/wapi/cloud/paypal/subscription/${id}`
    },
    SUBSCRIPTION_CANCEL: {
      method: 'POST',
      path: id =>
        `${window.cloud.url}/wapi/cloud/paypal/v1/billing/subscriptions/${id}/cancel`
    },
    SUBSCRIPTION_SUSPEND: {
      method: 'POST',
      path: id =>
        `${window.cloud.url}/wapi/cloud/paypal/v1/billing/subscriptions/${id}/suspend`
    },
    SUBSCRIPTION_ACTIVATE: {
      method: 'POST',
      path: id =>
        `${window.cloud.url}/wapi/cloud/paypal/v1/billing/subscriptions/${id}/activate`
    }
  },
  USER: {
    SESSION_CHECK: {
      method: 'GET',
      path: () => `${window.cloud.url}/wapi/cloud/user/sessionCheck`
    },
    UPDATE: {
      method: 'POST',
      path: () => `${window.cloud.url}/wapi/cloud/user/update`
    },
    LIST: {
      method: 'POST',
      path: () => `${window.cloud.url}/wapi/cloud/user/list`
    },
    LIST_EXCEL: {
      method: 'POST',
      path: () => `${window.cloud.url}/wapi/cloud/user/list/excel`
    }
  },
  NOTICE: {
    GET_ONE: {
      method: 'GET',
      path: () => `${window.cloud.url}/wapi/cloud/notice/one`
    },
    GET_ALL: {
      method: 'GET',
      path: () => `${window.cloud.url}/wapi/cloud/notice/all`
    },
    NEW: {
      method: 'POST',
      path: () => `${window.cloud.url}/wapi/cloud/notice/new`
    },
    UPDATE: {
      method: 'POST',
      path: () => `${window.cloud.url}/wapi/cloud/notice/update`
    }
  },
  ADMIN: {
    ASSIGMENT_LIST: {
      method: 'GET',
      path: () => `${window.cloud.url}/wapi/cloud/admin/assigment/list`
    },
    ASSIGMENT_CREATE: {
      method: 'POST',
      path: () => `${window.cloud.url}/wapi/cloud/admin/assigment/create`
    },
    ASSIGMENT_UPDATE: {
      method: 'POST',
      path: () => `${window.cloud.url}/wapi/cloud/admin/assigment/update`
    },
    ASSIGMENT_DELETE: {
      method: 'POST',
      path: () => `${window.cloud.url}/wapi/cloud/admin/assigment/delete`
    },
    FASOO_TOTAL_STAT: {
      method: 'POST',
      path: () => `${window.cloud.url}/wapi/stat/fasoo/totalStat`
    },
    FASOO_WG_COUNT_STAT: {
      method: 'POST',
      path: () => `${window.cloud.url}/wapi/stat/fasoo/workgroupCountStat`
    },
    FASOO_DOC_CREATE_COUNT_STAT: {
      method: 'POST',
      path: () => `${window.cloud.url}/wapi/stat/fasoo/docCreateCountStat`
    },
    FASOO_DOC_USAGE_COUNT_STAT: {
      method: 'POST',
      path: () => `${window.cloud.url}/wapi/stat/fasoo/docUsageCountStat`
    },
    FASOO_WORKGROUP_LIST: {
      method: 'POST',
      path: () => `${window.cloud.url}/wapi/stat/fasoo/workgroupList`
    },
    FASOO_DOC_LOG_LIST: {
      method: 'POST',
      path: () => `${window.cloud.url}/wapi/stat/fasoo/docLogList`
    },
    FASOO_WORKGROUP_LIST_EXCEL: {
      method: 'POST',
      path: () => `${window.cloud.url}/wapi/stat/fasoo/workgroupList/excel`
    },
    FASOO_DOC_LOG_LIST_EXCEL: {
      method: 'POST',
      path: () => `${window.cloud.url}/wapi/stat/fasoo/docLogList/excel`
    },
    FASOO_WORKGROUP_NAME_LIST: {
      method: 'POST',
      path: () => `${window.cloud.url}/wapi/stat/fasoo/workgroupNameList`
    },
    FASOO_WORKGROUP_USAGE_STAT: {
      method: 'POST',
      path: () => `${window.cloud.url}/wapi/stat/fasoo/workgroupUsageStat`
    }
  }
}



// WEBPACK FOOTER //
// ./src/apis.js